import formatNumber from './format-number';

export default (value: number): string => {
  if (value >= 1000000) {
    // 1500000 -> 1.5m bu
    const formattedVal = formatNumber(value / 1000000, 2);
    return `${formattedVal}m bu`;
  }
  // 8000 -> 8k bu
  const formattedVal: String = formatNumber(Math.round(value / 1000));
  return `${formattedVal}k bu`;
};
